import { toOrderMapPoints } from './utils/toOrderMapPoints'
import { Phase } from '@/features/orders/constants/app'
import { RootState } from '@/redux/store'
import { createSelector } from '@reduxjs/toolkit'

const selectMapOrderValues = createSelector(
    [
        (state: RootState) => state.orders.uuidOrderMap,
        (state: RootState) => state.orders.uuidsByPhase[Phase.New],
        (state: RootState) => state.orders.uuidsByPhase[Phase.InProgress],
        (state: RootState) => state.orders.uuidsByPhase[Phase.Future],
    ],
    (orders, ...phaseUuids) => {
        const activeUuids = phaseUuids.flat()

        return activeUuids.map((uuid) => orders[uuid])
    }
)

export const selectOrderMapPoints = createSelector([selectMapOrderValues], toOrderMapPoints, {
    memoizeOptions: {
        resultEqualityCheck: (
            a: ReturnType<typeof toOrderMapPoints>,
            b: ReturnType<typeof toOrderMapPoints>
        ) =>
            a.length === b.length &&
            a.every((point, index) => {
                const other = b[index]
                return (
                    point.id === other.id &&
                    point.label === other.label &&
                    point.coordinate[0] === other.coordinate[0] &&
                    point.coordinate[1] === other.coordinate[1]
                )
            }),
    },
})
